import Raven from 'raven-js';
const sentryPrefix = 'ui-tool-access';
class ToolAccessRequestException extends Error {
  constructor(name = '', message = '', ...args) {
    super(message, ...args);
    this.message = message;
    this.name = `ToolAccessRequestException - ${name}`;
  }
}
export function reportRequestException(requestName, errorResponse, extra = {}) {
  try {
    var _errorResponse$cause, _chirpError$reason, _errorResponse$cause$, _errorResponse$cause2;
    const chirpError = (_errorResponse$cause = errorResponse.cause) === null || _errorResponse$cause === void 0 ? void 0 : _errorResponse$cause.cause;
    const errorReason = (_chirpError$reason = chirpError === null || chirpError === void 0 ? void 0 : chirpError.reason) !== null && _chirpError$reason !== void 0 ? _chirpError$reason : 'UNKNOWN_REASON';
    const status = (_errorResponse$cause$ = (_errorResponse$cause2 = errorResponse.cause) === null || _errorResponse$cause2 === void 0 ? void 0 : _errorResponse$cause2.status) !== null && _errorResponse$cause$ !== void 0 ? _errorResponse$cause$ : 'unknown';
    const errorMessage = `[${sentryPrefix}][${status}][${requestName}]`;
    const toolAccessRequestException = new ToolAccessRequestException(String(errorReason), errorMessage);
    Raven.captureException(toolAccessRequestException, {
      level: 'error',
      extra: Object.assign({}, chirpError, extra)
    });
  } catch (e) {
    Raven.captureException(new Error('Unhandled request exception'), {
      level: 'error',
      extra: Object.assign({}, errorResponse, extra)
    });
  }
}